import { useContext } from 'react';
import { PleditorContext } from './context';
export const usePleditor = () => {
    const context = useContext(PleditorContext);
    if (!context) {
        throw new Error('usePleditor must be used as a child to <PleditorProvider>');
    }
    return context;
};
